import {
  InventoryItemDispositionSchema,
  InventoryItemGradeSchema,
  InventoryItemKindSchema,
  InventoryItemLifecycleStatusSchema,
} from "@redotech/redo-ims-db-schema/inventory-item-schema";
import { GradeAcceptance } from "@redotech/redo-return-settings-common/grade-mapping";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const GradeAcceptanceSchema = z.enum([
  GradeAcceptance.ACCEPT,
  GradeAcceptance.REJECT,
  GradeAcceptance.FLAG_FOR_REVIEW,
]);

const inventoryItemSchema_ = z.object({
  id: z.string(),
  kind: InventoryItemKindSchema,
  itemPrimary: z.string().nullable(),
  itemSubtext: z.string().nullable(),
  returnIdHex: z.string().nullable(),
  locationId: z.string(),
  locationName: z.string(),
  quantity: z.number(),
  grade: InventoryItemGradeSchema.nullable(),
  gradeAcceptance: GradeAcceptanceSchema.nullable(),
  disposition: InventoryItemDispositionSchema.nullable(),
  status: InventoryItemLifecycleStatusSchema,
  createdAt: z.date(),
});
export const inventoryItemSchema: z.ZodType<InventoryItem> =
  inventoryItemSchema_;
export interface InventoryItem extends z.infer<typeof inventoryItemSchema_> {}

export const getInventoryItems = unaryRpc({
  name: "getInventoryItems" as const,
  input: z.object({
    returnsCenterId: z.string().optional(),
    kinds: z.array(InventoryItemKindSchema).optional(),
    grades: z.array(InventoryItemGradeSchema).optional(),
    dispositions: z.array(InventoryItemDispositionSchema).optional(),
    statuses: z.array(InventoryItemLifecycleStatusSchema).optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    page: z.number().min(0).optional(),
    pageSize: z.number().min(1).max(500).default(50),
  }),
  output: z.object({
    items: z.array(inventoryItemSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
});

export type InventoryItemsOutput = z.infer<
  (typeof getInventoryItems)["output"]
>;
